import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_checkbox",
  "use": "svg_checkbox-usage",
  "viewBox": "0 0 12 9",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\" id=\"svg_checkbox\"><path d=\"M4.445 8.611.555 4.722l1.39-1.389 2.5 2.445L10.055.11l1.39 1.389-7 7.111Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol